<!-- <app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>

<div style="display: flex; justify-content: space-between; align-items: center; padding: 10px;">
    <h2 mat-dialog-title style="margin: 0;">Clause Audit Trail - {{_data.clauseNumber}}</h2>
    <button mat-raised-button [mat-dialog-close]="true" 
        style="background-color: #ffe600; color: black; font-weight: bold;">Close</button>
</div>

<mat-dialog-content class="mat-typography" style="overflow-x: auto;">
    <div style="min-width: 900px;">
    <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        
        <ng-container matColumnDef="RecordId">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Record ID</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.RecordId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Action">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.Action}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="FieldName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Field Name</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.FieldName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="OldValue">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Old Value</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.OldValue}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NewValue">
            <mat-header-cell *matHeaderCellDef mat-sort-header>New Value</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.NewValue}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="UpdatedOn">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Updated On</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.ModfiedOn | date:'dd/MMM/yyyy HH:mm'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="UpdatedBy">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Updated By</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.ModifiedBy}} </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <div *ngIf="dataSource && dataSource.data && dataSource.data.length === 0" class="no-data">
        No audit trail records found for this clause.
    </div>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
    </div>
</mat-dialog-content>

 -->

 <app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>

<!-- HEADER -->
<div class="dialog-header">
    <h2>Clause Audit Trail - {{ _data.clauseNumber }}</h2>

    <button mat-raised-button color="primary"
            [mat-dialog-close]="true"
            class="close-btn">
        Close
    </button>
</div>


<!-- CONTENT -->
<mat-dialog-content>

    <div class="table-wrapper">

        <table mat-table [dataSource]="dataSource" matSort class="audit-table">

            <!-- Record ID -->
            <ng-container matColumnDef="RecordId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Record ID</th>
                <td mat-cell *matCellDef="let row">{{ row.RecordId }}</td>
            </ng-container>

            <!-- Action -->
            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let row">
                    <span >
                        {{ row.ActionID }}
                    </span>
                </td>
            </ng-container>

            <!-- Field Name -->
            <ng-container matColumnDef="FieldName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Field Name</th>
                <td mat-cell *matCellDef="let row">{{ row.FieldName }}</td>
            </ng-container>

            <!-- Old Value -->
            <ng-container matColumnDef="OldValue">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Old Value</th>
                <td mat-cell *matCellDef="let row">
                    <div class="cell-text">{{ row.OldValue }}</div>
                </td>
            </ng-container>

            <!-- New Value -->
            <ng-container matColumnDef="NewValue">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>New Value</th>
                <td mat-cell *matCellDef="let row">
                    <div class="cell-text new-value">{{ row.NewValue }}</div>
                </td>
            </ng-container>

            <!-- Updated On -->
            <ng-container matColumnDef="ModifiedOn">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated On</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.ModifiedOn  }}
                </td>
            </ng-container>

            <!-- Updated By -->
            <ng-container matColumnDef="UpdatedBy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated By</th>
                <td mat-cell *matCellDef="let row">{{ row.ModifiedBy }}</td>
            </ng-container>

            <!-- HEADER + ROW -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>

        <!-- NO DATA -->
        <div *ngIf="dataSource?.data?.length === 0" class="no-data">
            No audit trail records found for this clause.
        </div>

        <!-- PAGINATOR -->
        <mat-paginator
            [pageSize]="10"
            [pageSizeOptions]="[10, 25, 50, 100]"
            showFirstLastButtons>
        </mat-paginator>

    </div>

</mat-dialog-content>
